import { memo } from 'react'
import { Helmet } from 'react-helmet'


export default memo(({ title, description, og, twitter }) => {
  return (
    <Helmet>
      <title>
        {title}
      </title>
      <meta
        name="description"
        content={description}
      />
      {
        og?.url && (
          <meta property="og:url" content={`https://www.mixmeister.com${og.url}`} />
        )
      }
      {
        og?.type && (
          <meta property="og:type" content={og.type} />
        )
      }
      {
        og?.title && (
          <meta property="og:title" content={og.title} />
        )
      }
      {
        og?.description && (
          <meta property="og:description" content={og.description} />
        )
      }
      {
        og?.image && (
          <meta
            property="og:image"
            content={`https://www.mixmeister.com${og.image.childImageSharp.gatsbyImageData.images.fallback.src}`}
          />
        )
      }
      {
        twitter?.card && (
          <meta name="twitter:card" content={twitter.card} />
        )
      }
      {
        twitter?.domain && (
          <meta property="twitter:domain" content={twitter.domain} />
        )
      }
      {
        twitter?.url && (
          <meta property="twitter:url"
                content={`https://www.mixmeister.com${twitter.url}`}
          />
        )
      }
      {
        twitter?.title && (
          <meta name="twitter:title" content={twitter.title}
          />
        )
      }
      {
        twitter?.description && (
          <meta
            name="twitter:description"
            content={twitter.description}
          />
        )
      }
      {
        twitter?.image && (
          <meta
            name="twitter:image"
            content={`https://www.mixmeister.com${twitter.image.childImageSharp.gatsbyImageData.images.fallback.src}`}
          />
        )
      }
    </Helmet>
  )
})
